import { useParams, useSearchParams } from 'next/navigation';
import { ExtendedFooterDestination } from './ExtendedFooterDestination';
import { ExtendedFooterListing } from './ExtendedFooterListing';
import { useLocale } from 'next-intl';
import { useMemo } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { SearchBlogs, TRAVELLING_TIPS_SLUG } from '@/query';

export const ExtendedFooter = (props) => {
  const locale = useLocale();
  const params = useParams();
  const searchParams = useSearchParams();

  const { data: blogData } = useSuspenseQuery(SearchBlogs, {
    variables: {
      filter: {
        placement: TRAVELLING_TIPS_SLUG,
        locale,
      },
    },
    errorPolicy: 'ignore',
  });

  const query = useMemo(
    () => ({
      groupSlug: params?.groupSlug,
      slug: params?.slug,
      startDate: searchParams.get('startDate'),
      endDate: searchParams.get('endDate'),
    }),
    [params, searchParams]
  );

  return (
    <div className="flex flex-col w-full">
      {query.groupSlug ? (
        <ExtendedFooterDestination
          {...props}
          locale={locale}
          query={query}
          blogData={blogData}
        />
      ) : (
        <ExtendedFooterListing
          {...props}
          locale={locale}
          query={query}
          blogData={blogData}
        />
      )}
    </div>
  );
};
